module.exports = __webpack_public_path__ + "static/media/google.516b9ec6.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Repertoire/assets/google.png
// module id = 517
// module chunks = 0